import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PlanilhaDto } from '../../../models/planilha-dto.model';
import { AbPlanilha } from 'app/abstract/full-pages/planilha/planilha.absact';

@Injectable({ providedIn: 'root' })
export class PlanilhaService extends AbPlanilha {

  constructor(http: HttpClient) {
    super(http);
  }

  public savePlanilha(planilha: PlanilhaDto): Observable<any> {
    return this.save("planilhas/", planilha);
  }

  public getResumo() {
    return this.get(`planilhas/resumo`);
  }

  public existeRegistrosBase() {
    return this.get(`planilhas/validar_existe_dados`);
  }

  public existeUsuariosCadastrados() {
    return this.get(`planilhas/existe_usuarios_cadastrados`);
  }

  public criarUsuario() {
    return this.get(`planilhas/criar_usuario`);
  }

  public reintegrar() {
    return this.get(`planilhas/executar_reintegracao`);
  }
}
